module.exports = __webpack_public_path__ + "img/ds_4.25fc31d3.jpg";